// extracted by mini-css-extract-plugin
export var editButton = "_o1-0";